import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import {
  getCountries,
  createOtpRequest,
  verifyOtpRequest,
  getMe
} from "../../services/apiService";
import Select from "carbon-components-react/lib/components/Select";
import SelectItem from "carbon-components-react/lib/components/SelectItem";
import MaskedInput from "react-text-mask";
import { toastTheError } from "../../services/toastService";
import DigitInput from "react-digit-input";
import "./loginView.css";
import { trackPageView } from "../../services/analyticsService";
import { connect } from "react-redux";
import { saveTeacher } from "../../store/actions";

class LoginView extends Component {
  constructor(props) {
    super(props);
    const lang = localStorage.getItem("lang") || "tr";
    this.state = {
      countries: [],
      step: 1,
      countryCode: lang == "tr" ? "1" : "2",
      phoneNumber: undefined,
      phoneNumberResponse: undefined,
      code: "",
      existing: localStorage.getItem("token")
    };

    this.checkLoginHealth = this.checkLoginHealth.bind(this);
  }

  componentDidMount() {
    getCountries().then((countries) => {
      this.setState({
        countries
      });
    });
    trackPageView("/login");
  }

  submitCodeForm = (e) => {
    e.preventDefault();
    const self = this;

    const phoneNumberId = this.state.phoneNumberResponse.phone_number.id;
    const otpCode = this.state.code;

    verifyOtpRequest(phoneNumberId, parseInt(otpCode))
      .then((result) => {
        if (result.auth_token && result.auth_token.length > 0) {
          localStorage.setItem("token", result.auth_token);
          return getMe();
        } else {
          throw new Error("Login error");
        }
      })
      .then((me) => {
        this.props.saveTeacher(me);

        if (me.phone_number.country_code) {
          self.setLocaleOnLogin(me.phone_number.country_code);
        }

        if (me.can_review_question) {
          self.props.history.push("/questionMatch");
        } else if (me.can_review_answer) {
          self.props.history.push("/questionMatch");
        } else {
          toastTheError(t("loginPermissionError"));
        }
      })
      .catch((error) => {
        toastTheError(error);
      });
  };

  setLocaleOnLogin(country_code) {
    switch (country_code) {
      case 90:
        this.setLocale("tr");
        break;
      case 91:
        this.setLocale("en");
        break;
    }
  }

  setLocale(lang) {
    const { i18n } = this.props;
    i18n.changeLanguage(lang);
    console.log(i18n);
  }

  submitPhoneForm = (e) => {
    e.preventDefault();

    createOtpRequest(this.state.countryCode, this.state.phoneNumber)
      .then((result) => {
        if (result) {
          this.setState({
            phoneNumberResponse: result,
            step: 2
          });
          //this.startTimer();
        }
      })
      .catch((error) => {
        toastTheError(error);
      });
  };

  printKunduzVisio() {
    return (
      <div className="login-logo-wrapper">
        <div>Kunduz</div> &nbsp; <div style={{ fontWeight: 700 }}>Visio</div>
      </div>
    );
  }

  printCodeForm() {
    const { t } = this.props;
    return (
      <div className="code-wrapper">
        {this.printKunduzVisio()}
        <form onSubmit={this.submitCodeForm}>
          <div>
            <DigitInput
              acceptedCharacters={/^[0-9]$/}
              length={4}
              value={this.state.code}
              onChange={(code) => this.setState({ code })}
            >
              {(props) => (
                <div className="digit-wrapper">
                  <input
                    type="tel"
                    autoFocus
                    className="bx--text-input digit-input"
                    {...props[0]}
                  />
                  <input
                    type="tel"
                    className="bx--text-input digit-input"
                    {...props[1]}
                  />
                  <input
                    type="tel"
                    className="bx--text-input digit-input"
                    {...props[2]}
                  />
                  <input
                    type="tel"
                    className="bx--text-input digit-input"
                    {...props[3]}
                  />
                </div>
              )}
            </DigitInput>
          </div>
          <div className="flex-line" style={{ marginTop: "16px" }}>
            <button
              className="bx--btn bx--btn--primary w100"
              type="submit"
              style={{ justifyContent: "center", padding: "0" }}
            >
              {t("submit")}
            </button>
          </div>
        </form>
      </div>
    );
  }

  printPhoneForm() {
    const { t } = this.props;
    return (
      <div className="phone-wrapper">
        {this.printKunduzVisio()}
        <form onSubmit={this.submitPhoneForm}>
          <div className="flex-line">
            <div style={{ width: "30%", marginRight: "8px" }}>
              <Select
                style={{ width: '20px' }}
                labelText={t("country")}
                defaultValue=""
                id="country-input"
                onChange={(e) => {
                  this.setState({
                    countryCode: parseInt(e.target.value)
                  });
                }}
              >
                <SelectItem disabled hidden value="" text="Country" />

                {this.state.countries &&
                  this.state.countries.map((country, index) => {
                    return (
                      <SelectItem
                        value={country.id}
                        key={index}
                        text={`${country.country_name} (+${country.code})`}
                      />
                    );
                  })}
              </Select>
            </div>

            <div style={{}} className="bx--form-item">
              <label htmlFor="phone-input" className="bx--label">
                {t("phoneNumber")}
              </label>
              <MaskedInput
                mask={[
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]}
                id="phone-input"
                className="bx--text-input"
                guide={true}
                //showMask
                placeholder="__________"
                onChange={(e) => {
                  this.setState({
                    phoneNumber: e.target.value
                  });
                }}
              />
            </div>
          </div>
          <div className="flex-line" style={{ marginTop: "16px" }}>
            <button
              className="bx--btn bx--btn--primary w100"
              type="submit"
              style={{ justifyContent: "center", padding: "0" }}
            >
              {t("submit")}
            </button>
          </div>
        </form>
      </div>
    );
  }

  checkLoginHealth() {
    if (this.state.existing && !this.props.teacher) {
      localStorage.clear();
      //toastMessage("Logout Successful");
      this.props.history.push("/");
    } else {
      return <Redirect to="/questionMatch" />;
    }
  }

  render() {
    if (this.state.existing) {
      this.checkLoginHealth();
    }
    return (
      <div className="view login-view">
        {this.state.step == 1 ? this.printPhoneForm() : this.printCodeForm()}
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    teacher: state.teacher
  };
};

const mapDispatchToProps = { saveTeacher };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("kunduz")(LoginView));
